import React,{useEffect,useState} from "react"
import stylesnav from "../nav/nav.module.scss"
function ImageFilter (props) {
  return(
      <div className={stylesnav.pills}>
        {props.children}
      </div>
  )
}
export default ImageFilter